/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ r: NonNullable<unknown> }} Return_Air_FlowInputs */



/**
* | output |
* | --- |
* | "Return flow: {r} m³/h" |
*
* @param {Return_Air_FlowInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const return_air_flow = /** @type {((inputs: Return_Air_FlowInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Return_Air_FlowInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Return flow: ${i?.r} m³/h`)
	return /** @type {LocalizedString} */ (`Débit reprise: ${i?.r} m³/h`)
});